import * as constants from 'redux/constants/app.constants';
import * as userConstants from 'redux/constants/user.constants';

const defaultState = {
  minimumPurchase: 0,
  discount: [10, 20],
  showPreloader: true,
  instagram: [],
  sliders: [],
  whatsapp: null,
  catalogs: [],
  prices: [],
  dataAnalytics: [],
  showMPButton: false,
  transferInfo: null,
  client: null,
  clients: [],
  envios:[],
  onlyUsers:false,
  publicKeyMP: null,
  cuotasMP: [],
  hayAcuerdoConVendedor: false,
  paymentMethods: [],
  addresses: [],
  frequentQuestions: [],
};

const appReducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.APP_CLIENT_REQUESTED:
    case constants.APP_INITIALIZE_REQUESTED:
    case constants.APP_DISCOUNT_REQUESTED:
    case userConstants.USER_LOGOUT_REQUESTED:
    case constants.APP_INSTAGRAM_REQUESTED:
    case constants.APP_MP_BUTTON_REQUESTED:
    case constants.APP_DATA_ANALYTICS_REQUESTED:
    case constants.APP_TRANSFER_INFO_REQUESTED:
      return {
        ...state,
        showPreloader: true,
      };
    case userConstants.USER_PROFILE_SUCCEEDED:
    case userConstants.USER_PROFILE_FAILED:
    case userConstants.USER_LOGOUT_SUCCEEDED:
    case userConstants.USER_LOGOUT_FAILED:
      return {
        ...state,
        showPreloader: false,
      };
    case constants.APP_DATA_ANALYTICS_SUCCEEDED:
      return {
        ...state,
        dataAnalytics: data.item,
      };
    case constants.APP_MINIMUM_PURCHASE_SUCCEEDED:
      return {
        ...state,
        minimumPurchase: data.item ? parseFloat(data.item.number, 0) : defaultState.minimumPurchase,
      };
    case constants.APP_CLIENT_SUCCEEDED:
      return{
        ...state,
        client: data.item,
      }
    case constants.APP_CLIENTS_SUCCEEDED:
      return {
        ...state,
        clients: Array.isArray(data) ? data : [],
      };
    case constants.APP_SLIDERS_GET_ALL_SUCCEEDED:
      return {
        ...state,
        sliders: data.items,
      };
    case constants.APP_WHATSAPP_SUCCEEDED:
      return {
        ...state,
        whatsapp: data.item,
      };
    case constants.APP_INSTAGRAM_SUCCEEDED:
      return {
        ...state,
        instagram: data.item,
      };
    case constants.APP_CATALOGS_SUCCEEDED:
      return {
        ...state,
        catalogs: data.item,
      };
    case constants.APP_PRICES_SUCCEEDED:
      return {
        ...state,
        prices: data.item,
      };
    case constants.APP_TRANSFER_INFO_SUCCEEDED:
      return {
        ...state,
        transferInfo: data.item,
      };
    case constants.APP_ENVIOS_SUCCEEDED:
      return {
        ...state,
        envios: data.item,
      };
    case constants.APP_ONLYUSERS_SUCCEEDED:
      return {
        ...state,
        onlyUsers: data.item,
      };
    case constants.APP_PUBLICKEYMP_SUCCEEDED:
      return {
        ...state,
        publicKeyMP:  data.public_key,
      };
    case constants.APP_CUOTASMP_SUCCEEDED:
      return {
        ...state,
        cuotasMP: data,
      };
    case constants.APP_DISCOUNT_SUCCEEDED:
      return {
        ...state,
        discount: data.items,
      };
    case constants.APP_PAYMENT_METHODS_SUCCEEDED:
      return {
        ...state,
        paymentMethods: data.items.filter(item => item.is_active === true),
        hayAcuerdoConVendedor: data.items.find(item => item.code === 'EFECTIVO')?.is_active,
        showMPButton: data.items.find(item => item.code === 'MP')?.is_active,
      };
    case constants.APP_ADDRESSES_SUCCEEDED:
      return {
        ...state,
        addresses: data.items || [],
      };
    case constants.APP_FREQUENT_QUESTIONS_SUCCEEDED:
      return {
        ...state,
        frequentQuestions: data.items || [],
      };
    case constants.APP_PAYMENT_METHODS_FAILED:
    case constants.APP_CUOTASMP_FAILED:
    case constants.APP_CLIENTS_FAILED:
    case constants.APP_CLIENT_FAILED:
    case constants.APP_PUBLICKEYMP_FAILED:
    case constants.APP_MP_BUTTON_FAILED:
    case constants.APP_DATA_ANALYTICS_FAILED:
    case constants.APP_CATALOGS_FAILED:
    case constants.APP_PRICES_FAILED:
    case constants.APP_SLIDERS_GET_ALL_FAILED:
    case constants.APP_WHATSAPP_FAILED:
    case constants.APP_INSTAGRAM_FAILED:
    case constants.APP_TRANSFER_INFO_FAILED:
    case constants.APP_ENVIOS_FAILED:
    case constants.APP_ONLYUSERS_FAILED:
    case constants.APP_ADDRESSES_FAILED:
    case constants.APP_FREQUENT_QUESTIONS_FAILED:
    default:
      return state;
  }
};

export default appReducer;
